import { getPrismicShopifyKey } from '~/utils/locales'

import {
  PRISMIC_TYPES,
  PRISMIC_TYPES_WITH_CARD,
  TPrismicWithCardTypesKey,
} from './prismic-types'

const DELIMITER = ', '

export const generateCard = (type: TPrismicWithCardTypesKey) =>
  [
    `${type}.category`,
    `${type}.card_name`,
    `${type}.card_image`,
    `${type}.card_image_hover`,
    `${type}.card_label`,
    `${type}.card_suptitle`,
    `${type}.card_pin`,
  ].join(DELIMITER)

const CARDS = Object.values(PRISMIC_TYPES_WITH_CARD)
  ?.map((type) => generateCard(type))
  ?.join(DELIMITER)

export const generateShopifyProduct = (type: string) => {
  return `${type}.${getPrismicShopifyKey()}`
}

const PRODUCTS_TYPES = [PRISMIC_TYPES.PRODUCT_V2, PRISMIC_TYPES.PRODUCT_SETS]

export const SHOPIFY_PRODUCTS = PRODUCTS_TYPES.map((type) =>
  generateShopifyProduct(type),
)?.join(DELIMITER)

export const FAQ_ITEM = [
  `${PRISMIC_TYPES.FAQ}.title, ${PRISMIC_TYPES.FAQ}.links, ${PRISMIC_TYPES.FAQ}.navigation_footer_title, ${PRISMIC_TYPES.FAQ}.navigation_footer_text, ${PRISMIC_TYPES.FAQ}.navigation_footer_links`,
].join(DELIMITER)

export const LEGAL_ITEM = [
  `${PRISMIC_TYPES.LEGAL_ITEM}.name, ${PRISMIC_TYPES.LEGAL}.links, ${PRISMIC_TYPES.LEGAL}.navigation_footer_title, ${PRISMIC_TYPES.LEGAL}.navigation_footer_text, ${PRISMIC_TYPES.LEGAL}.navigation_footer_links`,
].join(DELIMITER)

export const ARTICLE = [`${PRISMIC_TYPES.CATEGORY_ARTICLE}.name`]

export const PAGE = [SHOPIFY_PRODUCTS, CARDS, ARTICLE].join(DELIMITER)

export const PRODUCT_PAGE = [SHOPIFY_PRODUCTS].join(DELIMITER)
export const FAQ_PAGE_ITEM = [CARDS, FAQ_ITEM].join(DELIMITER)
export const LEGAL_PAGE_ITEM = [LEGAL_ITEM].join(DELIMITER)
export const BLOG_PAGE = [PAGE].join(DELIMITER)
export const ALL_FETCH_LINKS = [FAQ_ITEM, LEGAL_ITEM, PAGE].join(DELIMITER)

